import { ApiHttpService } from '../../services';

export const ManifestModule = {
    namespaced: true,
    actions: {
        async listManifests(context, payload) {
            const response = await ApiHttpService.getRequest('purchase-order/manifests', payload);
            return response.data;
        },
        async getManifest(context, payload) {
            const response = await ApiHttpService.getRequest('purchase-order/manifest', payload);
            return response.data;
        },
        async updateManifestSchedule(context, payload) {
            const response = await ApiHttpService.update(`purchase-order/manifests/${payload.manifestId}/schedule`, {
                connection: payload.connection,
                manifestNumber: payload.manifestNumber,
                scheduledDeliveryDate: payload.scheduledDeliveryDate,
                scheduledPortDate: payload.scheduledPortDate
            });
            return response.data;
        }
    }
};
